import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { ColumnOption } from "../../../constants/schema.js";
import { ActionType } from "./actions.js";
import { addColumnAction, changeColumnAutoIncrementAction, changeColumnCommentAction, changeColumnDataTypeAction, changeColumnDefaultAction, changeColumnDomainAction, changeColumnLogicalNameAction, changeColumnNameAction, changeColumnNameDerivedAction, changeColumnNotNullAction, changeColumnPrimaryKeyAction, changeColumnUniqueAction, moveColumnAction, removeColumnAction } from "./atom.actions.js";
import { bHas } from "../../../utils/bit.js";
//#region src/engine/modules/table-column/history.ts
var addColumn = (undoActions, { payload: { id, tableId } }) => {
	undoActions.push(removeColumnAction({
		id,
		tableId
	}));
};
var removeColumn = (undoActions, { payload: { id, tableId } }) => {
	undoActions.push(addColumnAction({
		id,
		tableId
	}));
};
var changeColumnName = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnNameAction({
		id,
		tableId,
		value: column.name
	}));
};
var changeColumnDataType = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnDataTypeAction({
		id,
		tableId,
		value: column.dataType
	}));
};
var changeColumnDefault = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnDefaultAction({
		id,
		tableId,
		value: column.default
	}));
};
var changeComment = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnCommentAction({
		id,
		tableId,
		value: column.comment
	}));
};
var changeColumnAutoIncrement = (undoActions, { payload: { id, tableId, value } }, { collections }) => {
	if (!query(collections).collection("tableColumnEntities").selectById(id)) return;
	undoActions.push(changeColumnAutoIncrementAction({
		id,
		tableId,
		value: !value
	}));
};
var changeColumnNotNull = (undoActions, { payload: { id, tableId, value } }, { collections }) => {
	if (!query(collections).collection("tableColumnEntities").selectById(id)) return;
	undoActions.push(changeColumnNotNullAction({
		id,
		tableId,
		value: !value
	}));
};
var changeColumnPrimaryKey = (undoActions, { payload: { id, tableId, value } }, { collections }) => {
	if (!query(collections).collection("tableColumnEntities").selectById(id)) return;
	undoActions.push(changeColumnPrimaryKeyAction({
		id,
		tableId,
		value: !value
	}));
};
var changeColumnUnique = (undoActions, { payload: { id, tableId, value } }, { collections }) => {
	if (!query(collections).collection("tableColumnEntities").selectById(id)) return;
	undoActions.push(changeColumnUniqueAction({
		id,
		tableId,
		value: !value
	}));
};
var changeColumnLogicalName = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnLogicalNameAction({
		id,
		tableId,
		value: column.logicalName
	}));
};
var changeColumnDomain = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnDomainAction({
		id,
		tableId,
		value: column.domainId
	}));
};
var changeColumnNameDerived = (undoActions, { payload: { id, tableId } }, { collections }) => {
	const column = query(collections).collection("tableColumnEntities").selectById(id);
	if (!column) return;
	undoActions.push(changeColumnNameDerivedAction({
		id,
		tableId,
		value: bHas(column.options, ColumnOption.nameDerived)
	}));
};
var moveColumn = (undoActions, { payload: { id, tableId, targetId } }, { collections }) => {
	const table = query(collections).collection("tableEntities").selectById(tableId);
	if (!table) return;
	const index = table.columnIds.indexOf(id);
	if (index === -1) return;
	const targetIndex = table.columnIds.indexOf(targetId);
	if (targetIndex === -1) return;
	const revertIndex = index < targetIndex ? index + 1 : index - 1;
	const newTargetId = table.columnIds[revertIndex];
	undoActions.push(moveColumnAction({
		id,
		tableId,
		targetId: newTargetId
	}));
};
var tableColumnPushUndoHistoryMap = {
	[ActionType.addColumn]: addColumn,
	[ActionType.removeColumn]: removeColumn,
	[ActionType.changeColumnName]: changeColumnName,
	[ActionType.changeColumnDataType]: changeColumnDataType,
	[ActionType.changeColumnDefault]: changeColumnDefault,
	[ActionType.changeColumnComment]: changeComment,
	[ActionType.changeColumnAutoIncrement]: changeColumnAutoIncrement,
	[ActionType.changeColumnNotNull]: changeColumnNotNull,
	[ActionType.changeColumnPrimaryKey]: changeColumnPrimaryKey,
	[ActionType.changeColumnUnique]: changeColumnUnique,
	[ActionType.moveColumn]: moveColumn,
	[ActionType.changeColumnLogicalName]: changeColumnLogicalName,
	[ActionType.changeColumnDomain]: changeColumnDomain,
	[ActionType.changeColumnNameDerived]: changeColumnNameDerived
};
//#endregion
export { tableColumnPushUndoHistoryMap };
